import React, { useEffect, lazy, createElement } from 'react';
import { SEO } from '../components/SEO';
export function ManufacturerRequestPage() {
  useEffect(() => {
    // Load Tally embed script
    const script = document.createElement('script');
    script.src = 'https://tally.so/widgets/embed.js';
    script.async = true;
    script.onload = () => {
      if (typeof (window as any).Tally !== 'undefined') {
        ;
        (window as any).Tally.loadEmbeds();
      }
    };
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return <>
      <SEO title="Request Manufacturer Access — Aspect" description="Request access to verified, rights-cleared photography of real product installations." data-id="element-522" />
      <div className="max-w-3xl mx-auto" data-id="element-523">
        <h1 className="text-3xl md:text-4xl font-medium leading-tight mb-6 text-aspect-black" data-id="element-524">
          Request manufacturer access
        </h1>
        <p className="text-lg text-aspect-black/80 mb-8" data-id="element-525">
          Request access to verified, rights-cleared photography of real product
          installations.
        </p>

        <p className="text-sm text-aspect-gray mb-12" data-id="element-526">
          Manufacturer access is reviewed to ensure category alignment and
          verification requirements.
        </p>

        <div className="w-full" style={{
        colorScheme: 'light',
        backgroundColor: '#F6F7F5'
      }} data-id="element-527">
          <iframe data-tally-src="https://tally.so/embed/xXj9DE?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1" loading="lazy" width="100%" height="1054" frameBorder="0" marginHeight={0} marginWidth={0} title="Manufacturer Access Request" className="w-full" data-id="element-528" />
        </div>
      </div>
    </>;
}